/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationFailedV1AllOf
 */
export interface SDKEventAuthenticationFailedV1AllOf {
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    person_id?: string;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    authenticated_methods?: Array<FactorMethod>;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    failed_authn_method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    failure_reason: string;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    failure_detail?: string;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1AllOf
     */
    challenge_id?: string;
}

/**
 * Check if a given object implements the SDKEventAuthenticationFailedV1AllOf interface.
 */
export function instanceOfSDKEventAuthenticationFailedV1AllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "failed_authn_method" in value;
    isInstance = isInstance && "failure_reason" in value;

    return isInstance;
}

export function SDKEventAuthenticationFailedV1AllOfFromJSON(json: any): SDKEventAuthenticationFailedV1AllOf {
    return SDKEventAuthenticationFailedV1AllOfFromJSONTyped(json, false);
}

export function SDKEventAuthenticationFailedV1AllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationFailedV1AllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'authenticated_methods': !exists(json, 'authenticated_methods') ? undefined : ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'failed_authn_method': FactorMethodFromJSON(json['failed_authn_method']),
        'failure_reason': json['failure_reason'],
        'failure_detail': !exists(json, 'failure_detail') ? undefined : json['failure_detail'],
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
        'challenge_id': !exists(json, 'challenge_id') ? undefined : json['challenge_id'],
    };
}

export function SDKEventAuthenticationFailedV1AllOfToJSON(value?: SDKEventAuthenticationFailedV1AllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_id': value.person_id,
        'authenticated_methods': value.authenticated_methods === undefined ? undefined : ((value.authenticated_methods as Array<any>).map(FactorMethodToJSON)),
        'failed_authn_method': FactorMethodToJSON(value.failed_authn_method),
        'failure_reason': value.failure_reason,
        'failure_detail': value.failure_detail,
        'handle': PersonHandleToJSON(value.handle),
        'challenge_id': value.challenge_id,
    };
}

